export class ProductCode {
  public static Free = ['FREEMEMBER'];
  public static Tier1 = ['Tier1'];
  public static Tier2 = ['Tier2'];
  public static Tier3 = ['Tier3'];
  public static Tier4 = ['Tier4'];
  public static STHs = ['STH','Tier1','Tier2'];
}
